<template>
    <el-card>
        <div slot="header" class="move">
            <h3>Broker Naf Leaderboard</h3>
        </div>

        <div class="mt-4 text-center">
            <span class="card-value"><h2>${{ value.toFixed(0) }}</h2></span>
        </div>
    </el-card>
</template>

<script>
export default {
    name: 'BrokerNafChart',
    components: {},
    props: [
        'brokerSettled',
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            brokerSettlements: [],
            datasets: [],
            labels: [],
            value: 0
        }
    },
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.brokerSettlements = event.brokerSettlement.settlements

            this.value = _.sum(this.brokerSettlements.values.total_naf)

            this.graphColorChange()
            this.graphBGColorChange()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.brokerSettlements = event.brokerSettlement.settlements

            this.value = _.sum(this.brokerSettlements.values.total_naf)

            this.graphColorChange()
            this.graphBGColorChange()
        })
    },
    computed: {},
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphBGColorChange() {
            return this.appearance == "white" ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255,255,255, 0.9)'
        },
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        }
    }
}
</script>

<style scoped>
.move {
    cursor: move;
}
</style>
